import React, { ReactNode } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

interface LayoutProps {
    children : ReactNode
}

export default function Layout({ children } : LayoutProps) {
    return (
        <div className="site-frame flex min-h-screen flex-col">
            <Header />
            <main className="flex-1">
                {children}
            </main>
            <Footer />
        </div>);
}
